/* eslint-disable react/display-name */

import { ComponentProps } from 'react';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';

import locales from '../locales';
import StripeElementModifier from './StripeElementModifier';

type ComponentType = ComponentProps<
  typeof StripeElementModifier
>['stripeElement'];

type InputProps = Omit<
  ComponentProps<typeof StripeElementModifier>,
  'stripeElement'
>;

const elementToInput =
  (component: ComponentType, placeholder: string) => (props: InputProps) => (
    <StripeElementModifier
      label={placeholder}
      stripeElement={component}
      {...props}
    />
  );

export const CardNumberInput = elementToInput(
  CardNumberElement,
  locales.cardNumberPlaceholder,
);
export const CardExpiryInput = elementToInput(
  CardExpiryElement,
  locales.cardExpiryPlaceholder,
);
export const CardCvcInput = elementToInput(
  CardCvcElement,
  locales.cvcPlaceholder,
);
